'use client';

import { Typography } from '@unity/cloud-ui';
import z from 'zod';
import { getComponentDocumentationUrl } from '@/utils/get-component-doc-url';

export const ListItem = (props: z.input<typeof listItemSchema>) => {
  return <Typography component="li" variant="body1" sx={{ '&>div': { pb: 1 } }} {...props} />;
};

const documentationURL = getComponentDocumentationUrl('list-item');

const descriptions = {
  listItem: {
    schema: `An item within a \\<ListGroup\\>.\n\n\n\n**Example**\n\`\`\`mdx\n<ListItem>\n  The content of the item\n</ListItem>\n\`\`\`\n\n${documentationURL}`,
    children: 'The content of the item. Can be anything.',
  },
};

export const listItemSchema = z
  .object({
    children: z.any().describe(descriptions.listItem.children),
  })
  .describe(descriptions.listItem.schema);
